import { useEffect, useState } from 'react';

import { SparklesIcon } from 'lucide-react';

import { Button } from 'components/Button';
import { Flex } from 'components/layout/Flex';
import { Typography } from 'components/typography';
import { CloneLineage, fetchCloneLineage } from 'lib/api/fetchCloneLineage';
import { Maybe } from 'types/UtilityTypes';

type CloneRecapProps = {
  loadId: number;
  onOpenLoad: (identifier: string) => void;
};

export default function CloneRecap({ loadId, onOpenLoad }: CloneRecapProps) {
  const [lineage, setLineage] = useState<Maybe<CloneLineage>>(null);
  useEffect(() => {
    let cancelled = false;
    setLineage(null);
    void fetchCloneLineage(loadId).then((result) => {
      if (!cancelled && result.isOk()) setLineage(result.value);
    });
    return () => {
      cancelled = true;
    };
  }, [loadId]);

  if (!lineage?.sourceLoadIdentifier?.trim() || lineage.sourceLoadId === loadId)
    return null;
  return (
    <Flex
      align='center'
      className='w-full min-w-0 gap-1.5 px-4 pt-1 text-accent-main'
      aria-label='AI clone history'
    >
      <SparklesIcon size={14} className='shrink-0' aria-hidden='true' />
      <Typography variant='body-xs' className='min-w-0 text-inherit'>
        Cloned from{' '}
        <Button
          buttonNamePosthog={null}
          variant='unstyled'
          size='auto'
          className='h-auto whitespace-normal break-all p-0 text-xs text-inherit underline underline-offset-2'
          aria-label={`Open source load ${lineage.sourceLoadIdentifier}`}
          onClick={() => onOpenLoad(lineage.sourceLoadIdentifier)}
        >
          {lineage.sourceLoadIdentifier}
        </Button>
      </Typography>
    </Flex>
  );
}
